import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantInventoryCategories } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

/**
 * The controller sets alwaysPaginate, so an unbounded call returns only the first page and
 * categories past it vanish from the item form and the dashboard chart labels. Same reason
 * useAllInventoryItems exists.
 */
export const useInventoryCategories = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.INVENTORY_CATEGORIES, orgSlug, restaurantId], () =>
    tenantInventoryCategories({ orgSlug, restaurantId }, { page: 1, limit: 1000 })
  );
};
